//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { cancel,progress,couponCancel } from '../../model/appointment/appointmentService';
import { getMyDate } from '@/utils/commonUtils'
import { store } from "@/observable/store"

export default {
    name: "reservation-status",
    data(){
        return {
            uuid:null,
            hospital:{},
            patient:{},
            info:{},
            title:'提交预约',
            status_title:'预约成功',
            status_title_last:'已完成',
            gatCard:process.env.VUE_APP_GAT_CARD,
        }
    },
    computed: {
        refid(){
            return store.refid
        },
        gatCardFlag(){
             return this.$route.query.gatCardFlag
        }
    },
    created() {
        window.scrollTo(0,0);  
        this.uuid = this.$route.query.uuid;
        // 埋点
      this.STATISTICS('load','sybao_ins_appointment_result_page')
      
      this.info={
            status_title:'提交申请',
            status: "1",
            status_describe: "预约结果将于明日发送至您的手机",
            project_name: "牙齿清洁保障计划",
            panoramic_photo: false,
            panoramic_photo_type: "",
            correction_plan: false,
            correction_plan_type: "",
        }
             
        this.hospital = {
            name:this.$route.query.addressName,
            address:this.$route.query.address,
            longitude:this.$route.query.longitude,
            latitude:this.$route.query.latitude,
        
        }
        this.patient = {
            name: this.$route.query.name,
            card_no: this.$route.query.card_no,
            phone: this.$route.query.phone,
            appointment_time: this.$route.query.time,
        }
    },
    methods: {
        mapClick(){
            //console.log(this.hospital.longitude)
            this.$router.push({
                path: "/map",
                query:{
                    lng:this.hospital.longitude,
                    lat: this.hospital.latitude
                }
            });
        },
    }
   
}
